
import { BEDROOM_NORTH, BEDROOM_SOUTH, KITCHEN, LIVING_ROOM, OFFICE, OUTSIDE } from "./common";

export const LocationMap = {
  BEDROOM_NORTH: BEDROOM_NORTH,
  BEDROOM_SOUTH: BEDROOM_SOUTH,
  KITCHEN: KITCHEN,
  LIVING_ROOM: LIVING_ROOM,
  OFFICE: OFFICE,
  OUTSIDE: OUTSIDE,
};

export type Location = typeof LocationMap[keyof typeof LocationMap];

export const Locations = Object.values(LocationMap);

export const LocationSensorMap: {[key: Location]: string} = {};

LocationSensorMap[LocationMap.BEDROOM_NORTH] = '28-02131372b9aa';
LocationSensorMap[LocationMap.BEDROOM_SOUTH] = '28-021317e57baa';
LocationSensorMap[LocationMap.KITCHEN] = '28-01131b22e56b';
LocationSensorMap[LocationMap.LIVING_ROOM] = '28-02131804b1aa';
LocationSensorMap[LocationMap.OFFICE] = '28-021312ec03aa';
LocationSensorMap[LocationMap.OUTSIDE] = '28-01131abc0f90';

export const SensorLocationMap: { [sensor_id: string]: Location } = {
  '28-02131372b9aa': LocationMap.BEDROOM_NORTH,
  '28-021317e57baa': LocationMap.BEDROOM_SOUTH,
  '28-01131b22e56b': LocationMap.KITCHEN,
  '28-02131804b1aa': LocationMap.LIVING_ROOM,
  '28-021312ec03aa': LocationMap.OFFICE,
  '28-01131abc0f90': LocationMap.OUTSIDE,
};
